export type DeleteCookieOptions = {
  path?: string;
  domain?: string;
};

export const deleteCookie = (
  name: string,
  options: DeleteCookieOptions = {},
) => {
  if (typeof document !== "undefined") {
    const { path = "/", domain } = options;

    const pathPart = `path=${path}`;
    const domainPart = domain ? `domain=${domain}` : "";
    const parts = [pathPart, domainPart].filter(Boolean).join("; ");

    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${parts}; secure`;
  }
};
